import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import MultiAppAuthenticationPopup from '../../../components/MultiAppAuthentication/Popup';

const mapStateToProps = (state: StoreState) => {
	const { multiAppAuthenticationInfos } = state;
	const { accessibleApps } = multiAppAuthenticationInfos;
	return { accessibleApps };
};

export default connect(mapStateToProps)(MultiAppAuthenticationPopup);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MultiAppAuthentication/Popup/index.tsx